import React from 'react'
import { MenuCountBadge } from 'components/layout/MenuCountBadge/MenuCountBadge'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { reviewsSelectors } from 'store/reviews'

interface IPendingReviewsBadgeProps {
  children: React.ReactNode
}

export const PendingReviewsBadge: React.FC<IPendingReviewsBadgeProps> = ({
  children
}) => {
  const pendingCount = useAppSelector(reviewsSelectors.selectPendingCount)

  return <MenuCountBadge count={pendingCount}>{children}</MenuCountBadge>
}
